import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const messageService = {
    getQuizResponse: (params) => axiosService.get(urls.messages.quizResponse, { params }).then(value => value.data),
    updateQuizResponse: (id, data) => axiosService.patch(`${urls.messages.quizResponse}/${id}`, data).then(value => value.data),
};

export { messageService };
